var exports = {
  "X7": "UserProfileBadges.module__containerModal___by1CZW",
  "b1": "UserProfileBadges.module__containerInline___by1CZW",
  "gB": "UserProfileBadges.module__moreBadges___by1CZW",
  "j4": "UserProfileBadges.module__containerModalMobile___by1CZW",
  "pP": "UserProfileBadges.module__containerModalDesktop___by1CZW",
  "RS": "UserProfileBadges.module__containerPopout___by1CZW",
  "Qk": "UserProfileBadges.module__badgeMobile___by1CZW",
  "EJ": "UserProfileBadges.module__badgeDesktop___by1CZW",
  "X8": "UserProfileBadges.module__sequenceBadge___by1CZW",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___by1CZW",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___by1CZW",
  "nf": "UserProfileBadges.module__link___by1CZW",
  "$J": "UserProfileBadges.module__linkButton___by1CZW",
  "tt": "UserProfileBadges.module__hoverCard___by1CZW",
  "I": "UserProfileBadges.module__hoverCardIcon___by1CZW",
  "Z3": "UserProfileBadges.module__hoverCardTitle___by1CZW",
  "Ox": "UserProfileBadges.module__hoverCardDetail___by1CZW",
  "SD": "UserProfileBadges.module__hoverCardSequence___by1CZW",
};

module.exports = exports;
